module.exports = __webpack_public_path__ + "img/icon-pfeil-slider_rechts_schwarz.3ea6f3bc.svg";